import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setSceneProps: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 详情
export const setScenePropDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 缩略图
export const setScenePropThumb: Mutation<IModuleState> = (state, payload) => {
  state.thumb.data = payload.data;
  state.thumb.loading = payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.name = payload.name;
  state.confirm.title = payload.title || '';
  state.confirm.content = payload.content || '';
};

// 价格弹窗
export const setPriceDialog: Mutation<IModuleState> = (state, payload) => {
  state.priceDialog.data = payload.data;
  state.priceDialog.visible = !!payload.visible;
  state.priceDialog.loading = !!payload.loading;
};

// 搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
